import React, { Component } from "react";
// react component used to create charts
import SweetAlert from "react-bootstrap-sweetalert";
import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
  formatFormData,
} from '../../../utils/utils';

import Button from "../../../components/CustomButton/CustomButton.jsx";
import {Col, ControlLabel, FormControl, FormGroup, Row} from "react-bootstrap";
import Card from "react-credit-cards";
import 'react-credit-cards/lib/styles.scss';
import Payment from "payment";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import rest from "../../../API/api";
import TCPDF from "../../../documents/TRO-subscription-website-terms-and-conditions.pdf";
import Checkbox from "../../../components/CustomCheckbox/CustomCheckbox";

class Finish_Step2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SubscriptionChange: this.props.getStore().SubscriptionChange,
      EventType: this.props.getStore().EventType,
      SubscriptionType: "",
      SubscriptionMultiShopCount: 0,
      SubscriptionDate: "",
      SubscriptionPrice: 0,
      number: '',
      name: '',
      expiry: '',
      cvc: '',
      zip: '',
      issuer: '',
      focused: '',
      agree: false,
      formData: null,
      numberError: null,
      nameError: null,
      expiryError: null,
      cvcError: null,
      zipError: null,
      agreeError: null,
      issuerError: null,
      focusedError: null,
      formDataError: null,
      cancelNotes: "",
      SubscriptionTypeError: null,
      SubscriptionMultiShopCountError: null,
      SubscriptionDateError: null,
      cancelNotesError: null,
      alert: null
    };
    this.saveSubscriptionEvent = this.saveSubscriptionEvent.bind(this);
    this.handleAgreeCheckbox = this.handleAgreeCheckbox.bind(this);
    this.isValidated = this.isValidated.bind(this);
  }
  handleCallback = ({ issuer }, isValid) => {
    if (isValid) {
      this.setState({ issuer });
    }
  };

  handleInputFocus = ({ target }) => {
    this.setState({
      focused: target.name,
    });
  };

  handleInputChange = ({ target }) => {
    if (target.name === 'number') {
      target.value = formatCreditCardNumber(target.value);
    } else if (target.name === 'expiry') {
      target.value = formatExpirationDate(target.value);
    } else if (target.name === 'cvc') {
      target.value = formatCVC(target.value);
    }

    this.setState({ [target.name]: target.value });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { issuer } = this.state;
    const formData = [...e.target.elements]
        .filter(d => d.name)
        .reduce((acc, d) => {
          acc[d.name] = d.value;
          return acc;
        }, {});

    this.setState({ formData });
    this.form.reset();
  };

  static get contextTypes() {
    return {
      router: PropTypes.object
    };
  }

  isValidated() {
    const userInput = this._grabUserInput(); // grab user entered vals
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var regex_zipcode = /\d{5}/;
    var regex_cardnumber,cardnumberlength;
    switch(this.state.EventType) {

      //run the CC and validation routines for Update_CC and Reactivate Event Types
      case "Update_CC":
      case "Reactivate":
        var plan = true;
        //If its reactivate then we need to validate the Subscription Plan, Multi-shop, Price and Date
        if (this.state.EventType === "Reactivate") {
          ((this.state.SubscriptionType === "Select a subscription type") || (this.state.SubscriptionType === ""))
              ? this.setState({
                SubscriptionTypeError: (
                    <small className="text-danger">
                      Please provide a subscription type.
                    </small>
                )
              })
              : this.setState({SubscriptionTypeError: null});

          var type = ((this.state.SubscriptionType !== "Select a subscription type") && (this.state.SubscriptionType !== ""));

          this.state.SubscriptionMultiShopCount === ""
              ? this.setState({
                SubscriptionMultiShopCountError: (
                    <small className="text-danger">
                      Use value of 0 if none.
                    </small>
                )
              })
              : this.setState({SubscriptionMultiShopCountError: null});
          var count = this.state.SubscriptionMultiShopCount !== "";

          this.state.SubscriptionDate === ""
              ? this.setState({
                SubscriptionDateError: (
                    <small className="text-danger">
                      Please provide a subscription type to calculate renewal date.
                    </small>
                )
              })
              : this.setState({SubscriptionDateError: null});
          var subscription = this.state.SubscriptionDate !== "";
          plan = type && count && subscription;
        }
        //Now lets validate the CC information
        //Set the correct reg expression based on card issuer
        const issuer = Payment.fns.cardType(this.state.number);
        switch(issuer){
          case "amex":
            regex_cardnumber = /[\d| ]{17}/;
            cardnumberlength = 17;
            break;
          case "dinersclub":
            regex_cardnumber = /[\d| ]{16}/;
            cardnumberlength = 16;
            break;
          default:
            regex_cardnumber = /[\d| ]{19}/;
            cardnumberlength=19;
            break;

        }
        var regex_expiry=/^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/;
        var regex_cvc=/\d{3,4}/;
        ((regex_cardnumber.test(this.state.number) === false)||(this.state.number.length > cardnumberlength))
            ? this.setState({
              numberError: (
                  <small className="text-danger">
                    Please provide the complete Credit Card Number.
                  </small>
              )
            })
            : this.setState({ numberError: null });

        //check each required field for validation
        this.state.name === ""
            ? this.setState({
              nameError: (
                  <small className="text-danger">
                    Please provide the name on the credit card.
                  </small>
              )
            })
            : this.setState({ nameError: null });
        var name = this.state.name !== "";

        var today, someday;
        var exMonth=this.state.expiry.slice(0,2);
        //Works for the next 80 years :)
        var exYear="20" + this.state.expiry.slice(3);
        today = new Date();
        someday = new Date();
        someday.setFullYear(exYear, exMonth, 1);

        ((regex_expiry.test(this.state.expiry) === false) || (someday < today))
            ? this.setState({
              expiryError: (
                  <small className="text-danger">
                    Please provide a valid expiration date.
                  </small>
              )
            })
            : this.setState({ expiryError: null });

        regex_cvc.test(this.state.cvc) === false
            ? this.setState({
              cvcError: (
                  <small className="text-danger">
                    Please provide the Security Code.
                  </small>
              )
            })
            : this.setState({ cvcError: null });

          ((regex_zipcode.test(this.state.zip) === false)||(this.state.zip.length !== 5))
              ? this.setState({
                  zipError: (
                      <small className="text-danger">
                          Please provide a valid zip code.
                      </small>
                  )
              })
              : this.setState({ zipError: null });

        (this.state.agree === false)
            ? this.setState({
              agreeError: (
                  <small className="text-danger">
                    Please Acknowledge that you agree to our T&Cs
                  </small>
              )
            })
            : this.setState({ agreeError: null });
        var agree = this.state.agree !== false;

        valid = (regex_cardnumber.test(this.state.number) && name &&
            regex_expiry.test(this.state.expiry) && regex_cvc.test(this.state.cvc) && regex_zipcode.test(this.state.zip) && agree && plan && (someday > today) );
        break;
      case "Cancel":
        (this.state.cancelNotes === "")
            ? this.setState({
              cancelNotesError: (
                  <small className="text-danger">
                   Please provide us some context on why you are canceling your subscription,
                  </small>
              )
            })
            : this.setState({cancelNotesError: null});
        var notes = (this.state.cancelNotes !== "");
        var valid = notes;
        break;
    }
    if(valid)
      this.props.updateStore({
        ...userInput,
        sentEmail: false // use this to notify step4 that some changes took place and prompt the user to save again
      });
    return valid;
  }

  successAlert(success){
    //Setup the alert and use the context to route to the home page once logged in.
    if(success) {
      this.setState({
        alert: (
            <SweetAlert
                success
                title="Subscription Change Request Sent!"
                style={{display: "block"}}

                onConfirm={() => this.context.router.history.push("/Home")}
                onCancel={() => this.context.router.history.push("/Home")}
                confirmBtnBsStyle="info"
            >
              Watch for an email notifying you that your changes have been processed!
            </SweetAlert>
        )
      });
    }
    else
    {
      this.setState({
        alert: (
            <SweetAlert
                danger
                style={{display: "block"}}
                title="Opps! Something went wrong!"
                onConfirm={() => this.setState({alert: null})}
                onCancel={() => this.setState({alert: null})}
                confirmBtnBsStyle="danger"
            >
              Sorry we had an issue completing your changes, please try again!
            </SweetAlert>
        )
      });
    }
  }

  saveSubscriptionEvent(event) {
    event.preventDefault();
    if(this.isValidated()) {
      fetch(rest.register, {
        headers: new Headers({
          'Content-Type': 'application/json;charset=UTF-8',
          'x-api-key': rest.apiKey
        }),
        method: 'POST',

        body: JSON.stringify({
          RequestingTenantId: this.props.getStore().RequestingTenantId,
          EventType: this.state.EventType,
          Userid: this.props.getStore().Userid,
          Kioskid: "N/A",
          Email: this.props.getStore().Email,
          Company: this.props.getStore().Company,
          Fname: this.props.getStore().Fname,
          Lname: this.props.getStore().Lname,
          Address: this.props.getStore().Address,
          City: this.props.getStore().City,
          State: this.props.getStore().State,
          Country: this.props.getStore().Country,
          Postal: this.props.getStore().Postal,
          Phone: this.props.getStore().Phone,
          SubscriptionDate: this.props.getStore().SubscriptionDate,
          SubscriptionStatus: false,
          SubscriptionType: this.props.getStore().SubscriptionType,
          SubscriptionPrice: this.props.getStore().SubscriptionPrice,
          SubscriptionMultiShopCount: this.props.getStore().SubscriptionMultiShopCount,
          CustomerXRef: "N/A",
          UserHash: this.props.getStore().Hash,
          UserSalt: this.props.getStore().Salt,
          KioskHash: "N/A",
          KioskSalt: "N/A",
          CCNumber: this.props.getStore().CCnumber,
          CCName: this.props.getStore().CCname,
          CCExpiry: this.props.getStore().CCexpiry,
          CCCvc: this.props.getStore().CCCvc,
          CCZip: this.props.getStore().CCZip,
          CCIssuer: Payment.fns.cardType(this.state.number),
          Processed: false,
          Notes: this.props.getStore().Notes
        })
      })
          .then(response => response.json())
          .then(data => {
            //Lets send an email to our admin account for notification that a registration is waiting
            var message = '<html><body>';
            message = message + "<h2> You have a new Subscription Change Request generated from our Website:</h2><br><br>"
            //message = message + '<img src="//css-tricks.com/examples/WebsiteChangeRequestForm/images/wcrf-header.png" alt="Website Change Request" />';
            message = message + '<table rules="all" style="border-color: #666;" cellpadding="10">';
            message = message + "<tr style='background: #eee;'><td><strong>" + "Subscription Request Event Type: " + this.state.EventType + "</strong> </td><td>" + "Details" + "</td></tr>";
            message = message + "<tr><td><strong>Customer Name:</strong> </td><td>" + this.props.getStore().Fname + " " + this.props.getStore().Lname + "</td></tr>";
            message = message + "<tr><td><strong>Customer Phone Number:</strong> </td><td>" + this.props.getStore().Phone + "</td></tr>";
            message = message + "<tr><td><strong>Customer Email:</strong> </td><td>" + this.props.getStore().Email + "</td></tr>";
            message = message + "<tr><td><strong>Customer Address:</strong> </td><td>" + this.props.getStore().Address + "</td></tr>";
            message = message + "<tr><td><strong>Customer City:</strong> </td><td>" + this.props.getStore().City + "</td></tr>";
            message = message + "<tr><td><strong>Customer State:</strong> </td><td>" + this.props.getStore().State + "</td></tr>";
            message = message + "<tr><td><strong>Customer Zip Code:</strong> </td><td>" + this.props.getStore().Postal + "</td></tr>";
            message = message + "<tr><td><strong>Customer Country:</strong> </td><td>" + this.props.getStore().Country + "</td></tr>";
            message = message + "</table>";
            message = message + "</body></html>";
            fetch(rest.sendmail, {
              headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': rest.apiKey
              }),
              method: 'POST',

              body: JSON.stringify({
                to: rest.email,
                from: rest.email,
                subject: "Subscription Change Request",
                message: message
              })
            })
                .then(response => response.json())
                .then(data => {
                  this.successAlert(true);
                })
                .catch(error => console.error(error));

            this.successAlert(true);
          })
          .catch(error => console.error(error));
    }

  }

  _grabUserInput() {
    switch(this.state.EventType) {
      case "Update_CC":
        return {
          //Use a check statement to be sure we collect based off right activity type.
          CCnumber: this.state.number,
          CCname: this.state.name,
          CCexpiry: this.state.expiry,
          CCCvc: this.state.cvc,
          CCZip: this.state.zip,
          agree: document.getElementById("agree").checked,
          SubscriptionType: this.props.getStore().SubscriptionType,
          SubscriptionMultiShopCount: this.props.getStore().SubscriptionMultiShopCount,
          SubscriptionPrice:this.props.getStore().SubscriptionPrice,
          SubscriptionDate: this.props.getStore().SubscriptionDate,
        };
      case "Reactivate":
        return {
          CCnumber: this.state.number,
          CCname: this.state.name,
          CCexpiry: this.state.expiry,
          CCCvc: this.state.cvc,
          CCZip: this.state.zip,
          agree: document.getElementById("agree").checked,
          SubscriptionType: ReactDOM.findDOMNode(this.subscriptionType).value,
          SubscriptionMultiShopCount: document.getElementById('MultiShopCount').value,
          SubscriptionPrice: document.getElementById('SubscriptionPrice').value,
          SubscriptionDate: document.getElementById('SubscriptionDate').value,
        };
      case "Cancel":
        return {
          Notes: document.getElementById('cancelNotes').value,
          CCnumber: "N/A",
          CCname: "N/A",
          CCexpiry: "N/A",
          CCCvc: "N/A",
          CCZip: "N/A",
          CCIssuer: "N/A",
          agree: true,
          SubscriptionType: this.props.getStore().SubscriptionType,
          SubscriptionMultiShopCount: this.props.getStore().SubscriptionMultiShopCount,
          SubscriptionPrice:this.props.getStore().SubscriptionPrice,
          SubscriptionDate: this.props.getStore().SubscriptionDate,
        };
    }
  }

  handleAgreeCheckbox = () => {
    this.setState({
      agree: !this.state.agree,
    });
  };

  calculateSubscriptionPrice= () => {
    //Lets get the subscription type and multi-shop count values and calculate their price.
    let count_s = document.getElementById('MultiShopCount').value;
    let type_s = ReactDOM.findDOMNode(this.subscriptionType).value;
    var todayDate = new Date();
    var tenantDate,mm,dd,yyyy;
    var tenantDate_s = "";
    let price = 0;
    switch(type_s){
      case "Monthly" :
        price = rest.Monthly + (count_s * rest.MultiShop);
        tenantDate = new Date(todayDate.setMonth(todayDate.getMonth()+1));
        //Lets store the subscription date into a mm/dd/yyyy string
        dd = tenantDate.getDate();
        mm = tenantDate.getMonth() + 1; //January is 0!
        yyyy = tenantDate.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }
        if (mm < 10) {
          mm = '0' + mm;
        }
        tenantDate_s = mm + '/' + "01" + '/' + yyyy;
        break;
      case "Yearly" :
        price = rest.Yearly + (count_s * rest.MultiShop * 12);
        tenantDate = new Date(todayDate.setMonth(todayDate.getMonth()+12));
        //Lets store the subscription date into a mm/dd/yyyy string
        dd = tenantDate.getDate();
        mm = tenantDate.getMonth() + 1; //January is 0!
        yyyy = tenantDate.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }
        if (mm < 10) {
          mm = '0' + mm;
        }
        tenantDate_s = mm + '/' + "01" + '/' + yyyy;
        break;
      default:
        price = count_s * rest.MultiShop;
    }
    this.setState({
      SubscriptionPrice: price,
      SubscriptionDate: tenantDate_s
    });
  };

  handleChangeSubscription = () => {
    this.setState({ SubscriptionType: ReactDOM.findDOMNode(this.subscriptionType).value });
    this.calculateSubscriptionPrice();
  };

  handleChangeSubscriptionMultiShopCount = () => {
    this.setState({ SubscriptionMultiShopCount: document.getElementById('MultiShopCount').value });
    this.calculateSubscriptionPrice();
  };

  render() {
    //Lets set the header based on the EventType
    var header_s, formBody;
    switch(this.state.EventType){
      //Both Updatea and Reactivate need new CC information, adjust header and subscription plan fields accordingly
      case "Update_CC":
      case "Reactivate":
        (this.state.EventType === "Reactivate") ? (
          header_s = "Please select your plan and provide your credit card to reactivate your subscription"
            ) : (
          header_s = "Please provide us your current Credit Card Information"
        );
        formBody =(
            <div>
              {(this.state.EventType === "Reactivate") ? (
                  <div>
                    <Row>
                      <Col md={3} mdOffset={1}>
                        <FormGroup>
                          <ControlLabel>Subscription Plan. <span className="text-danger">*</span> </ControlLabel>
                          {(this.state.SubscriptionTypeError === null) ? (
                              <FormControl componentClass="select"
                                           className="valid"
                                           placeholder="Select a subscription type"
                                           ref={subscriptionType => { this.subscriptionType= subscriptionType }}
                                           onChange={this.handleChangeSubscription}
                                           value={this.state.SubscriptionType}
                              >
                                <option value="Select a subscription type">Select a subscription type</option>
                                <option value="Monthly">Monthly</option>
                                <option value="Yearly">Yearly</option>
                              </FormControl>
                          ) : (
                              <FormControl componentClass="select"
                                           className="error"
                                           placeholder="Select a subscription type"
                                           ref={subscriptionType => { this.subscriptionType= subscriptionType }}
                                           onChange={this.handleChangeSubscription}
                                           value={this.state.SubscriptionType}
                              >
                                <option value="Select a subscription type">Select a subscription type</option>
                                <option value="Monthly">Monthly</option>
                                <option value="Yearly">Yearly</option>
                              </FormControl>
                          )}
                          {this.state.SubscriptionTypeError}
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <ControlLabel>Multi-Shop Count: <span className="text-danger">*</span></ControlLabel>
                          {(this.state.SubscriptionMultiShopCountError === null) ? (
                              <FormControl
                                  className="valid"
                                  id="MultiShopCount"
                                  type="number"
                                  name="multishopcount"
                                  placeholder="ex: 0"
                                  value={this.state.SubscriptionMultiShopCount}
                                  onChange={this.handleChangeSubscriptionMultiShopCount}
                                  //onChange={event => this.setState({SubscriptionMultiShopCount: event.target.value})}
                              />
                          ) : (
                              <FormControl
                                  className="error"
                                  id="MultiShopCount"
                                  type="number"
                                  name="multishopcount"
                                  placeholder="ex: 0"
                                  value={this.state.SubscriptionMultiShopCount}
                                  onChange={this.handleChangeSubscriptionMultiShopCount}
                                  //onChange={event => this.setState({SubscriptionMultiShopCount: event.target.value})}
                              />
                          )}
                          {this.state.SubscriptionMultiShopCountError}
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <ControlLabel>Subscription Price (USD): <span className="text-danger">*</span></ControlLabel>
                          <FormControl
                              id="SubscriptionPrice"
                              type="number"
                              name="subscriptionprice"
                              placeholder="0"
                              value={this.state.SubscriptionPrice}
                              disabled={true}
                              //onChange={event => this.setState({SubscriptionPrice: event.target.value})}
                          />
                          {this.state.SubscriptionPriceError}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={10} mdOffset={1}>
                        <hr />
                        <h6>This is the date for your second billing event, we will bill the amount calculated above in
                          in the Subscription Price field for your selected plan upon signing up.</h6>
                        <hr />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={3} mdOffset={1}>
                        <FormGroup>
                          <ControlLabel>Next Renewal Date</ControlLabel>
                          <FormControl
                              id="SubscriptionDate"
                              type="text"
                              name="SubscriptionDate"
                              disabled={true}
                              placeholder="Next Subscription Renewal Date"
                              value={this.state.SubscriptionDate}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                  </div>
                  ) : (

                      <div></div>

              )};
              <div className="App-payment">
                <Card
                    number={this.state.number}
                    name={this.state.name}
                    expiry={this.state.expiry}
                    cvc={this.state.cvc}
                    focused={this.state.focused}
                    callback={this.handleCallback}

                />
              </div>
              <Row>
                <Col md={6} mdOffset={3}>
                  <FormGroup>
                    <ControlLabel>Credit Card Number <span className="text-danger">*</span></ControlLabel>
                    {(this.state.numberError === null) ? (
                        <FormControl
                            className="valid"
                            id="number"
                            type="tel"
                            name="number"
                            maxLength="19"
                            placeholder="Card Number E.g.: 49..., 51..., 36..., 37..."
                            value={this.state.number}
                            pattern="[\d| ]{16,22}"
                            onChange={this.handleInputChange}
                            onFocus={this.handleInputFocus}
                        />
                    ) : (
                        <FormControl
                            className="error"
                            id="number"
                            type="tel"
                            name="number"
                            maxlength="19"
                            placeholder="Card Number E.g.: 49..., 51..., 36..., 37..."
                            value={this.state.number}
                            pattern="[\d| ]{16,22}"
                            onChange={this.handleInputChange}
                            onFocus={this.handleInputFocus}
                        />
                    )}
                    {this.state.numberError}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6} mdOffset={3}>
                  <FormGroup>
                    <ControlLabel>Name on Credit Card <span className="text-danger">*</span></ControlLabel>
                    {(this.state.nameError === null) ? (
                        <FormControl
                            className="valid"
                            id="name"
                            type="text"
                            name="name"
                            placeholder="Name on Card"
                            value={this.state.name}
                            onChange={this.handleInputChange}
                            onFocus={this.handleInputFocus}
                        />
                    ) : (
                        <FormControl
                            className="error"
                            id="name"
                            type="text"
                            name="name"
                            placeholder="Name on Card"
                            value={this.state.name}
                            onChange={this.handleInputChange}
                            onFocus={this.handleInputFocus}
                        />
                    )}
                    {this.state.nameError}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2} mdOffset={3}>
                  <FormGroup>
                    <ControlLabel>Expiration <span className="text-danger">*</span></ControlLabel>
                    {(this.state.expiryError === null) ? (
                        <FormControl
                            className="valid"
                            id="expiry"
                            type="tel"
                            name="expiry"
                            placeholder="Valid Thru"
                            value={this.state.expiry}
                            pattern="\d\d/\d\d"
                            onChange={this.handleInputChange}
                            onFocus={this.handleInputFocus}
                        />
                    ) : (
                        <FormControl
                            className="error"
                            id="expiry"
                            type="tel"
                            name="expiry"
                            placeholder="Valid Thru"
                            value={this.state.expiry}
                            pattern="\d\d/\d\d"
                            onChange={this.handleInputChange}
                            onFocus={this.handleInputFocus}
                        />
                    )}
                    {this.state.expiryError}
                  </FormGroup>
                </Col>
                <Col md={2} >
                  <FormGroup>
                    <ControlLabel>CVC <span className="text-danger">*</span></ControlLabel>
                    {(this.state.cvcError === null) ? (
                        <FormControl
                            className="valid"
                            id="cvc"
                            type="tel"
                            name="cvc"
                            placeholder="CVC"
                            value={this.state.cvc}
                            pattern="\d{3,4}"
                            onChange={this.handleInputChange}
                            onFocus={this.handleInputFocus}
                        />
                    ) : (
                        <FormControl
                            className="error"
                            id="cvc"
                            type="tel"
                            name="cvc"
                            placeholder="CVC"
                            value={this.state.cvc}
                            pattern="\d{3,4}"
                            onChange={this.handleInputChange}
                            onFocus={this.handleInputFocus}
                        />
                    )}
                    {this.state.cvcError}
                  </FormGroup>
                </Col>
                  <Col md={2}>
                      <FormGroup>
                          <ControlLabel>Zip Code <span className="text-danger">*</span></ControlLabel>
                          {(this.state.zipError === null) ? (
                              <FormControl
                                  className="valid"
                                  id="zip"
                                  type="tel"
                                  name="zip"
                                  defaultValue={this.state.zip}
                                  placeholder="ex: 80107"
                                  value={this.state.zip}
                                  pattern="\d{5}"
                                  onChange={event => this.setState({ zip: event.target.value })}
                              />
                          ) : (
                              <FormControl
                                  className="error"
                                  id="zip"
                                  type="text"
                                  name="zip"
                                  defaultValue={this.state.zip}
                                  placeholder="ex: 80107"
                                  value={this.state.zip}
                                  pattern="\d{5}"
                                  onChange={event => this.setState({ zip: event.target.value })}
                              />
                          )}
                          {this.state.zipError}
                      </FormGroup>
                  </Col>
              </Row>
              <Row>
                <Col md={8} mdOffset={3}>
                  <hr />
                  <h6>All users of Tattoo Release Online (TRO) software are required to review, agree to, and abide by our software
                    terms and conditions provided from this link: <a href = {TCPDF} target = "_blank">Download our Terms and Conditions</a>.
                    Failure to do so can result in termination of your subscription and/or interruption of our service with you.</h6>
                  <hr />
                </Col>
              </Row>
              <Row>
                <Col md={7} mdOffset={3}>
                  <FormGroup>
                    {(this.state.agreeError === null) ? (
                        <Checkbox
                            className="valid"
                            id="agree"
                            number="agree"
                            label="I have reviewed and agree to the Terms and Conditions listed above."
                            value={this.state.agree}
                            onChange={this.handleAgreeCheckbox}
                            checked={this.state.agree}
                        />
                    ) : (
                        <Checkbox
                            className="error"
                            id="agree"
                            number="agree"
                            label="I have reviewed and agree to the Terms and Conditions listed above."
                            value={this.state.agree}
                            onChange={this.handleAgreeCheckbox}
                            checked={this.state.agree}
                        />
                    )}
                    {this.state.agreeError}
                  </FormGroup>
                </Col>
              </Row>
            </div>




        );
        break;

      case "Cancel":
        header_s = "Uh oh, we are sorry to see you go... ";
        formBody = (
          <Row>
            <Col md={7} mdOffset={1}>
              <FormGroup controlId="formControlsTextarea">
                <ControlLabel>Reason?</ControlLabel>
                <FormControl
                    id="cancelNotes"
                    rows="5"
                    name="cancel_Notes"
                    componentClass="textarea"
                    placeholder="Tell us why you are canceling?"
                    bsClass="form-control"
                    value={this.state.cancelNotes}
                    onChange={event => this.setState({cancelNotes: event.target.value})}
                />
                {this.state.cancelNotesError}
              </FormGroup>
            </Col>
          </Row>
        );
        break;
      default:
        break;
    }
    return (
      <div className="wizard-step">
        <h5 className="text-center">
          {header_s}
        </h5>
        {formBody}
        <div className="wizard-finish-button">
          <Button
            bsStyle="info"
            fill
            wd
            onClick={this.saveSubscriptionEvent}
            pullRight
          >
            Finish
          </Button>
        </div>
        {this.state.alert}
      </div>
    );
  }
}

export default Finish_Step2;



// WEBPACK FOOTER //
// ./src/views/Forms/ManageSubscriptionWizard/Finish_Step2.jsx